// Импорт CSS
import '../styles/main.css';

// Импорт модулей
import { App } from './modules/app.js';

// Точка входа в приложение
document.addEventListener('DOMContentLoaded', async () => {
  console.log('🌟 DOM загружен, начинаем инициализацию...');
  
  try {
    console.log('📦 Создаем экземпляр App...');
    const app = new App();
    
    console.log('🚀 Запускаем инициализацию...');
    await app.init();
    
    console.log('✅ Приложение успешно запущено!');
  } catch (error) {
    console.error('❌ Критическая ошибка:', error);
    console.error('Stack trace:', error.stack);
    
    // Показать пользователю сообщение об ошибке
    const errorMessage = document.createElement('div');
    errorMessage.className = 'error-message';
    errorMessage.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #e74c3c;
      color: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 10000;
      text-align: center;
      max-width: 500px;
    `;
    errorMessage.innerHTML = `
      <h3>Ошибка загрузки</h3>
      <p>Приложение не может быть загружено.</p>
      <p><strong>Ошибка:</strong> ${error.message}</p>
      <button onclick="window.location.reload()" style="
        background: white;
        color: #e74c3c;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 10px;
      ">Перезагрузить</button>
      <button onclick="console.log('Error details:', arguments.callee.error)" style="
        background: transparent;
        color: white;
        border: 1px solid white;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 10px;
        margin-left: 10px;
      ">Показать детали</button>
    `;
    errorMessage.querySelector('button:last-child').error = error;
    document.body.appendChild(errorMessage);
  }

  const yearSpan = document.getElementById('currentYear');
  if (yearSpan) {
    yearSpan.textContent = new Date().getFullYear();
  }
}); 